import { useState, useEffect } from 'react';
import { supabase } from 'utils/supabaseClient';

const useSupabaseSession = () => {
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        const getSession = async () => {
            const {
                data: { session },
                error,
            } = await supabase.auth.getSession();

            if (error) {
                console.error('Error fetching session:', error);
                return;
            }

            if (session?.access_token) {
                setAccessToken(session.access_token);
            }
        };

        getSession();
    }, []);

    return { accessToken };
};

export default useSupabaseSession;
